// @ts-strict

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ICheckedValue } from '@app/core/models/core-models';
import { CategoriesArray, CategoriesArrayCategory } from '../traffic-source-categories.component';
import { CategoryCheckedFilter } from '../traffic-source-category-subelements/traffic-source-category-subelements.component';

@Component({
  selector: 'app-traffic-source-category-elements',
  templateUrl: './traffic-source-category-elements.component.html',
  styleUrls: ['./traffic-source-category-elements.component.scss']
})
export class TrafficSourceCategoryElementsComponent implements OnInit {
  @Input() categoriesArray?: CategoriesArray;
  @Input() isEditMode: boolean = false;

  @Output() emitCheckedValues = new EventEmitter<number[]>();

  public hideRuleContent: boolean[] = [];

  public showAllData = false;
  public defaultNumberOfCategories = 5;

  public finalArray: CategoriesArrayCategory[] = [];
  public checkedValues: number[] = [];
  public defaultValue = 'all';

  public searchInput = '';

  public endpointParameterCategory: string = '';

  public activeCategoryIndex = null;

  private currentlyCheckedElement?: ICheckedValue;
  private showLessArray: any[] = [];

  constructor() {}

  get isAllChecked(): boolean {
    return this.currentlyCheckedElement?.id === 'all';
  }
  get disabled(): boolean {
    return !this.checkedValues.length && this.defaultValue === 'all';
  }

  ngOnInit(): void {
    if (this.isEditMode && this.categoriesArray) {
      this.checkElements(this.categoriesArray.categories);
      this.setHideRuleContent(this.categoriesArray.categories);
    }

    if (!this.searchInput) this.defineArrayOfData();
  }

  public searchFilter(): void {
    const categoriesArray = this.categoriesArray?.categories ?? [];
    this.searchInput = this.searchInput.trim();
    if (this.searchInput.trim().length >= 2) {
      this.finalArray = categoriesArray.filter(element => element.translated.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
      if (!this.finalArray.length) {
        categoriesArray.map(filter => {
          if (filter?.children?.filter(child => child.translated.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1).length) {
            const filterCopy = { ...filter };
            filterCopy.children = filterCopy.children.filter(child => child.translated.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
            this.finalArray = [filterCopy];
          } else {
            filter.children?.map(subchild => {
              if (subchild.children.filter(child => child.translated.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1).length) {
                this.finalArray = [filter];
              }
            });
          }
        });
      }
    } else if (this.searchInput.trim().length === 0) {
      this.activeCategoryIndex = null;
      this.defineArrayOfData();
    }
  }

  public toggleExpandable(index: number): void {
    this.hideRuleContent[index] = !this.hideRuleContent[index];
  }

  public setActiveCategoryIndex(element: any): void {
    const categoryIndex = this.getActiveCategoryIndex(element);
  }

  public showAll(): void {
    this.showAllData = true;
    this.defineArrayOfData();
  }

  public checkboxValue(event: Event, index: number | null, element: CategoriesArrayCategory): void {
    this.currentlyCheckedElement = {
      id: element.id,
      index: index ?? 0,
      quantity: element.quantity,
      childs: element.children as Omit<CategoriesArrayCategory, 'id'>[]
    };
    if ((event.target as HTMLInputElement).checked) {
      if (!this.checkedValues.includes(element.id)) {
        this.checkedValues.push(element.id);
      }
      if (element.children?.length) {
        element.children.map(child => {
          if (!this.checkedValues.includes(child.id)) {
            this.checkedValues.push(child.id);
            if (child.children?.length) {
              child.children.map(grandchild => {
                if (!this.checkedValues.includes(grandchild.id)) {
                  this.checkedValues.push(grandchild.id);
                }
              });
            }
          }
        });
      }
    } else {
      this.checkedValues = this.checkedValues.filter(value => value !== element.id);
      if (element.children?.length) {
        element.children.map(child => {
          this.checkedValues = this.checkedValues.filter(value => value !== child.id);
          if (child.children?.length) {
            child.children.map(grandchild => {
              this.checkedValues = this.checkedValues.filter(value => value !== grandchild.id);
            });
          }
        });
      }
    }
    if (this.checkedValues.length) {
      this.defaultValue = 'none';
    } else {
      this.defaultValue = 'all';
    }

    this.emitCheckedValues.emit(this.checkedValues);
  }

  public getCheckedSubelements(arrayOfSubelements: CategoryCheckedFilter): void {
    if (arrayOfSubelements.values.length) {
      this.defaultValue = 'none';
    } else if (!arrayOfSubelements.values.length && !this.checkedValues.length) {
      this.defaultValue = 'all';
    }

    const childsArray: number[] = [];
    const parentElement = this.categoriesArray?.categories.filter(el => el.id === arrayOfSubelements.elementID)[0];
    if (parentElement && parentElement.children?.length) {
      parentElement.children.map(child => {
        if (arrayOfSubelements.values.includes(child.id)) {
          childsArray.push(child.id);
        }
      });
      if (childsArray.length === parentElement.children.length) {
        arrayOfSubelements.values.push(parentElement.id);
      } else {
        arrayOfSubelements.values = arrayOfSubelements.values.filter(val => val !== parentElement.id);
      }
    }
    this.checkedValues = [...arrayOfSubelements.values];
    this.checkedValues = [...new Set(this.checkedValues)];
    this.setActiveCategoryIndex(parentElement);
    this.emitCheckedValues.emit(this.checkedValues);
  }

  public checkIfChecked(valueID: number): boolean {
    return this.checkedValues.some(element => element === valueID);
  }

  public countCheckedChildren(children: CategoriesArrayCategory[]): boolean {
    // lets count all children ang grand ....
    let countAll = 0;
    let counter = 0;
    children.map(el => {
      countAll++;
      if (this.checkIfChecked(el.id)) {
        counter++;
      }
      el.children?.map(subEl => {
        countAll++;
        if (this.checkIfChecked(subEl.id)) {
          counter++;
        }
      });
    });
    return countAll > counter && counter > 0;
  }

  private getActiveCategoryIndex(categoryElement: CategoriesArrayCategory): number {
    return this.finalArray.indexOf(categoryElement);
  }

  private defineArrayOfData(): void {
    if (this.categoriesArray && this.categoriesArray.categories.length > this.defaultNumberOfCategories) {
      this.showLessArray = this.categoriesArray.categories.slice(0, this.defaultNumberOfCategories);
    }
    if (this.categoriesArray && this.categoriesArray.categories.length > this.defaultNumberOfCategories && !this.showAllData) {
      this.finalArray = this.showLessArray;
    } else {
      if (!this.categoriesArray?.categories.length) {
        this.finalArray = [];
      } else {
        this.finalArray = this.categoriesArray.categories;
      }
    }
  }

  private setHideRuleContent(categoriesArr: CategoriesArrayCategory[]): void {
    this.hideRuleContent = categoriesArr.map(el => {
      if (el.checked === true) {
        return true;
      } else if (el.children?.length) {
        return this.checkChildren(el.children);
      } else {
        return false;
      }
    });
  }

  private checkElements(catArr: CategoriesArrayCategory[]): void {
    catArr.map(el => {
      if (el.checked) {
        this.checkboxValue({ target: { checked: true } } as any, null, el);
      } else if (el.children.length) {
        this.checkElements(el.children);
      }
    });
  }

  private checkChildren(arr: any[]): boolean {
    let value = false;
    for (let el of arr) {
      if (value) {
        break;
      }
      if (el.checked === true) {
        value = true;
      } else if (el.children?.length) {
        value = this.checkChildren(el.children);
      } else {
        value = false;
      }
    }
    return value;
  }
}
